import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const REF_STORAGE_KEY = "ref";

export const captureReferralFromUrl = (search?: string): string | null => {
    const ref = new URLSearchParams(search ?? window.location.search).get("ref");

    if (ref) {
        localStorage.setItem(REF_STORAGE_KEY, ref);
        return ref;
    }

    return localStorage.getItem(REF_STORAGE_KEY);
};

export const useReferral = () => {
    const [searchParams] = useSearchParams();
    const [referral, setReferral] = useState<string | null>(() =>
        localStorage.getItem(REF_STORAGE_KEY)
    );

    useEffect(() => {
        const ref = searchParams.get("ref");

        if (ref) {
            localStorage.setItem(REF_STORAGE_KEY, ref);
            setReferral(ref);
            return;
        }

        const savedRef = localStorage.getItem(REF_STORAGE_KEY);

        if (savedRef) {
            setReferral(savedRef);
        }
    }, [searchParams]);

    return referral;
};
